import { render, staticRenderFns } from "./TagJournal.vue?vue&type=template&id=d7a29484&scoped=true"
import script from "./TagJournal.vue?vue&type=script&lang=js"
export * from "./TagJournal.vue?vue&type=script&lang=js"
import style0 from "./TagJournal.vue?vue&type=style&index=0&id=d7a29484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a29484",
  null
  
)

export default component.exports